<script>
	import { toString } from '@carbon/icon-helpers';
	import { 
		Close16
	} from '@carbon/icons';

	import { onMount } from 'svelte';

	export let position = null;
	export let icon = undefined;
	export let message = '';
	export let duration = 0;
	export let closeButton = true;
	export let styling = '';

	export let _state = 'open';
	export let _events = null;

	let wrapper;
	let height = 0;
	let tm = null;
	let lock = false;

	$: pos = position ?
		Object.entries(position).map(
			p => [ p[0], ': ', p[1].toString(), typeof p[1] === 'number' ? 'px' : '' ].join('')
		).join('; ') + ';' :
		'';

	onMount(() => {
		height = wrapperHeight();
		if (_events && _events._onMount) {
			const callback = _events._onMount;
			callback({ height: height });
		}
		if (duration) {
			tm = setTimeout(close, duration);
		}
	});

	const eventName = 'WebkitTransition' in document.documentElement.style ? 'webkitTransitionEnd' : 'transitionend';
	
	function close() {
		if (!lock) {
			lock = true;
			if (tm)
				clearTimeout(tm);
			if (_events && _events._onCloseStart) {
				const callback = _events._onCloseStart;
				callback({ height: height });
			}
			wrapper.addEventListener(eventName, () => {
				if (_events && _events._onClose) {
					const callback = _events._onClose;
					callback({ height: height });
				}
				else {
					wrapper.parentNode.removeChild(wrapper);
				}
			}, { once: true });
			_state = 'close';
		}
	}
	
	function wrapperHeight() {
		const styles = window.getComputedStyle(wrapper);
		return wrapper.offsetHeight + Math.round(parseFloat(styles['marginBottom']));
	}
</script>

<style lang="scss">
  @import '../vars.scss';

	.warning {
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		box-sizing: border-box;
		padding-top: var(--padding-top, #{$spacing-base});
		padding-right: var(--padding-right, #{$spacing-base});
		padding-bottom: var(--padding-bottom, #{$spacing-base});
		padding-left: var(--padding-left, #{$spacing-base});
		width: var(--width, #{$sizing-width-03});
		color: var(--text-color, #{$color-text-04});
		background-color: var(--bg-color, #{$color-background-12});
		border-radius: var(--border-radius, #{$sizing-border-radius-01});
		box-shadow: 0px 0px 0px 3px rgba(0, 0, 0, .1);
		margin-top: 10px;
		line-height: 24px;
		margin-bottom: 20px;
		opacity: 0;
		-webkit-transition: margin-top .3s ease-out, opacity .3s ease-out, top .4s ease-out;
		transition: margin-top .3s ease-out, opacity .3s ease-out, top .4s ease-out;
	}
	
	.warning.with-close {
		padding-right: calc(var(--padding-right, #{$spacing-base}) / 2);
	}
	
	.warning.with-icon{
		padding-left: calc(var(--padding-right, #{$spacing-base}) / 2);
	}

	.warning.positioned {
		position: absolute;
		z-index: 3;
	}

	.warning.opened {
		margin-top: 0px;
		opacity: 1;
	}
	
	.warning.closed {
		margin-top: 0px;
		opacity: 0;
	}

	.icon {
		display: flex;
		flex: 0 0 auto;
		justify-content: center;
		align-items: center;
		cursor: pointer;
		width: 24px;
		height: 24px;
		color: var(--close-color, #{$color-text-02});
	}
	
	.icon:hover {
		background-color: var(--bg-icon-hover-color, #{$color-hover-02});
	}
</style>

<div
	class="warning {styling}"
	class:with-close="{closeButton}"
	class:with-icon="{icon}"
	class:positioned="{pos}"
	class:opened="{_state == 'open'}"
	class:closed="{_state == 'close'}"
	style="{pos}"
	bind:this="{wrapper}"
>
	<div>{message}</div>
	{#if closeButton}
		<div
			class="icon"
			on:click="{close}"
		>{@html toString(Close16)}</div>
	{/if}
</div>
